// extracted by mini-css-extract-plugin
module.exports = {"CardNova":"DashboardClasse_CardNova__3IldE"};